import React from 'react'
import Slider from './Slider'
import Contact from './Contact'
import Categories from './Categories'
import Service from './Service'
import Ctaarea from './Ctaarea'
import Teamarea from './Teamarea'
import Faqarea from './Faqarea'
import Contactarea from './Contactarea'
import Scrolltop from './Scrolltop'
import Testimonialarea from './Testimonialarea';
import Blogarea from './Blogarea';

function Home() {
  return (
    <>
  <Slider/>
  <Contact/>
  <Categories/> 
  <Service/>
  <Ctaarea/>
  <Teamarea/>
  <Testimonialarea/>
  <Faqarea/>
  <Blogarea/>
  <Contactarea/>
  <Scrolltop/>
    </>
  );
}

export default Home